import React from "react";
import CollapseItem from "./CollapseItem";

export type Question = {
  answers: string;
  questions: string;
};

type QuestionsProps = {
  questions: Array<Question>;
  header: string;
};

const Questions: React.FunctionComponent<QuestionsProps> = ({
  questions,
  header,
}): React.ReactElement => {
  return (
    <div className="questions desktop-container">
      <h2 className="questions__header">{header}</h2>

      {questions.map((q, index) => (
        <CollapseItem
          // onClick={() => this.handleDropDownChange(index)}
          className="questions__dropDownItem"
          // ref={(ref) => (this.q[index] = ref)}
          key={index}
          main={q.questions}
        >
          <div
            className="questions__dropDownContent"
            dangerouslySetInnerHTML={{ __html: q.answers }}
          />
        </CollapseItem>
      ))}
    </div>
  );
};

export default Questions;

// export default class Questions extends Component {
//   constructor(props) {
//     super(props);
//     this.q = [];
//   }
//
//   handleDropDownChange = (i) => {
//     this.q.forEach((item, index) => {
//       if (index !== i) {
//         item.closeDropDown();
//       }
//     });
//   };
//
//   render() {
//     const { header, questions } = this.props;
//
//
//   }
// }
